<template>
    <div>
        <div class="proj-toolbox-area">
            <h4>
                {{ $t('n.device') }} {{ $t('menu.status') }} {{ $t('menu.management') }}
                <b-badge class="badge-small">{{ deviceCount }}</b-badge>
            </h4>

            <div class="proj-toolbox-body text-left" v-if="list_gateways">
                <div v-for="(gateway, idx_g) in list_gateways" :key="idx_g" class="gateway-block">
                    <div v-if="user_admin" class="gateway-area">
                        <i :class="$tools.style.classIcon('gateway', 'block-title')"></i>
                        <span v-if="gateway.nickname != undefined">{{ gateway.nickname }}</span>
                        <span v-else class="err-msg">[ {{ $t('menu.no_name') }} ]</span>

                        <span class="block-text gateway-hashid">{{ gateway.hashid }}</span>
                        <span v-if="user_admin" class="block-text gateway-hashid">( Gateway ID = {{ gateway.gatewayid }} )</span>

                        <router-link v-if="user_admin"
                                     class="router-button"
                                     style="font-size: 1.4rem;"
                                     :to="{ name: 'Edit Gateway', params: { gatewayID: gateway.hashid } }">
                            <i class="fa fa-pencil-square"></i>
                        </router-link>

                        <b-badge v-if="gateway.is_virtual" variant="info" class="block-text">Virtual</b-badge>
                        <!-- <b-badge :variant="$tools.style.variantStatusButton('gateway', gateway.status, false)" class="block-text">
                            {{ $t('status.gateway.' + gateway.status ) }}
                        </b-badge> -->
                        <!-- <span class="block-text gateway-info"><i class="fa fa-desktop block-text"></i>Team Viewer：{{ gateway.tv_name }}</span> -->
                    </div>
                    <div>
                        <b-row class="device-area" v-for="(device, idx_d) in gateway.devices" :key="idx_d">

                            <b-col md="6" class="col">
                                <i :class="$tools.style.classIcon(device.type, 'block-text')"></i>
                                <span v-if="device.nickname != undefined">{{ device.nickname }}</span>
                                <span v-else class="err-msg">[ {{ $t('menu.no_name') }} ]</span>

                                <span class="block-text device-hashid">{{ device.hashid }}</span>
                                <span v-if="user_admin" class="block-text device-hashid">( Device ID = {{ device.deviceid }} )</span>

                                <router-link v-if="user_admin"
                                            class="router-button"
                                            style="font-size: 1.4rem;"
                                            :to="{ name: 'Edit Device', params: { deviceID: device.hashid } }">
                                    <i class="fa fa-pencil-square"></i>
                                </router-link>

                                <div class="block-text">
                                    <b-badge :variant="$tools.style.variantStatusButton('device', device.status, false)" class="block-text">
                                        {{ $t('status.device.' + device.status ) }}
                                    </b-badge>
                                </div>
                            </b-col>
                            <b-col md="6" class="col">
                                    <div class="area-overflow-x grab-bing scroll-style" v-dragscroll v-if="checkStatusEditable(device.status, 'edit_area')">
                                        <div class="block-text change-status-title">
                                            <i class="fa fa-gear"></i>
                                        </div>
                                        <div class="block-text">
                                            <b-button-group>
                                                <template v-for="(status, idx_status) in admin_DeviceStatus_List">
                                                    <b-button v-if="checkStatusEditable(device.status, status.value)" :key="idx_status"
                                                            :variant="status.buttonVariant" size="sm"
                                                            :pressed="device.status == status.value"
                                                            @click="updateDeviceStatus(device, status.value)">
                                                        {{ $t('status.device.' + status.value) }}
                                                    </b-button>
                                                </template>
                                            </b-button-group>
                                        </div>
                                    </div>
                            </b-col>

                        </b-row>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex'
    import { dragscroll } from 'vue-dragscroll'  // 滑鼠可拖拉 scroll 區域

export default {
    directives: {
        'dragscroll': dragscroll,
    },
    props: {
        projectID: {
            type: [String, Number],
            required: true,
        },
    },
    data () {
        return {
            uploading: false,
            list_gateways: [],
        }
    },
    mounted ()
    {
        // 取得專案裝置
        this.getProjectDevices(this.projectID);
    },
    computed: {
        ...mapState({
            'user_admin': state => state.user.is_admin,
            'project_detail': state => state.project.project_detail,
            'project_devices': state => state.project.project_devices,
            'project_editable': state => state.project.project_editable,
            'admin_DeviceStatus_List': state => state.device.list_status,
        }),

        checkDisabled ()
        {

            return false;
        },

        deviceCount ()
        {
            let _count_gateways = 0, _count_devices = 0;

            this.list_gateways.forEach( _gateway => {
                _count_gateways += 1

                _count_devices += _gateway.devices.length
            })

            if ( this.user_admin ) return 'gateways： ' + _count_gateways + ' , devices： ' + _count_devices
            else                   return _count_devices
        },
    },
    watch:
    {
        projectID (val, oldVal)
        {
            if (val != undefined)
            {
                // console.log( val )
                this.getProjectDevices(val);
            }
        },
    },
    methods: {

        checkStatusEditable (status_now, status_update, is_admin = false)
        {
            // if (this.user_admin == true) return true
            // else if (is_admin == true) return true
            // else
            // {
                // 檢查當下狀態，使用者是否可以更改
                let _user_editable = false
                switch (status_now)
                {
                    // case 'inventory': _user_editable = true; break;
                    case 'active':    _user_editable = true; break;
                    case 'resting':   _user_editable = true; break;

                    default:          _user_editable = false; break;
                }

                if (_user_editable == true)
                {
                    // 設定使用者可以按的狀態按鈕
                    switch (status_update)
                    {
                        case 'edit_area': return true;  // 是否要顯示編輯狀態按鈕

                        case 'active':    return true;
                        case 'resting':   return true;

                        default:          return false;
                    }
                }
                else return false;
            // }
        },

        popConfirm (device, status)
        {
            let _confirmAlert = this.$t('other.confirm_this_update')
            _confirmAlert += '\n ' + device.hashid
            if (device.nickname) _confirmAlert += ' ' + device.nickname

            _confirmAlert += '\n ' + this.$t('status.device.' + device.status) + ' => ' + this.$t('status.device.' + status)

            return confirm( _confirmAlert )
        },

        updateDeviceStatus (device, status)
        {
            if ( device.status != status && this.popConfirm(device, status) )
            {
                this.uploading = true;

                let _data = {
                    status:         status,
                    // note:           device.note,
                };

                let _show_info = device.hashid + ( device.nickname ? ' ' + device.nickname : '' )
                let _url = ''
                if (this.user_admin)
                {
                    _url = this.$config.getAPI_URL('Admin_Device', { deviceID: device.hashid })
                }
                else
                {
                    _url = this.$config.getAPI_URL('Update_Project_Device_Info', { projectID: this.projectID, deviceID: device.hashid })
                }

                const options = {
                    method:'PUT',
                    url:   _url,
                    data:  _data
                }
                this.$http(options)
                .then( res => {

                    this.uploading = false;
                    this.$toastr.s( this.$t('other.update_succeeded'),
                                    this.$t('menu.updated') + ' ' + this.$t('n.device') + ' ' + this.$t('menu.status') + ': ' + _show_info );
                    this.getProjectDevices( this.projectID );
                })
                .catch( err => {

                    this.uploading = false;
                    this.$toastr.e( this.$t('other.update_failed') + '<br>' + err.data.status + '<br>' + err.data.message,
                                    this.$t('menu.updated') + ' ' + this.$t('n.device') + ' ' + this.$t('menu.status') + ': ' + _show_info );
                })


                // 送出使用者操作紀錄 --------------------
                let _OPLog = {
                    user_id: this.$store.state.user.id,
                    type: 'write',
                    detail: {
                        page: 'project',
                        action: 'set device status',
                        querySettings: {
                            'project ID':     this.projID,
                            'project name':   this.project_detail.name,
                            'device ID':      device.deviceid,
                            'device HashID':  device.hashid,
                            'device type':    device.type,
                            'device status':  device.status + ' => ' + status,
                            'device nickname': device.nickname,
                        },
                        pageInfo: {
                            'is admin':       this.user_admin,
                            'user role':      this.project_detail.role,
                            'project status': this.project_detail.status,
                            'service level':  this.project_detail.service_level,
                        },
                    },
                }
                this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
                // 送出使用者操作紀錄 --------------------
            }
        },

        getProjectDevices (_projectID)
        {
            this.list_gateways = []
            this.$store.dispatch('project/getProjectDevices', _projectID)
                .then( res => {

                    let _new_list = []
                    let _all_gateways = res.data.project.gateways.slice()
                    _all_gateways.forEach( _gw => {
                        _new_list.push( this.$tools.data.deepCopy_object(_gw) )
                    })

                    this.list_gateways = _new_list
                })
                .catch( err => {
                })
        },

    }

}
</script>

<style lang="scss" scoped>

.fa-gear
{
    vertical-align: middle;
    font-size: 1.5rem;
    color: #266028;
}

.gateway-block
{
    margin-bottom: 40px;
}

.gateway-area
{
    margin-bottom: 10px;
    color: #266028;
    font-size: 1.2rem;
}
.gateway-hashid
{
    font-size: 0.8rem;
    margin-left: 8px;
}
.gateway-info {
    font-size: 0.95rem;
    margin-left: 15px;
}

.device-area
{
    padding-bottom: 10px;
    margin: 5px 5px 15px 15px;
    font-size: 1.1rem;
    border-bottom: 1px solid #d3d3d3;
    .col
    {
        margin-bottom: 5px;
    }
}
.device-hashid
{
  font-size: 0.8rem;
  margin-left: 8px;
}
.device-info {
    font-size: 0.95rem;
    margin-left: 15px;
}

.change-status-title
{
  font-size: 0.95rem;
}

</style>
